import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "Creative",
  icon: "✨",
  templates: [
    {
      title: "Bedtime Story",
      content: `Create a gentle bedtime story for a young child, written for spoken delivery.
- The main character is a [kind little fox] named [Hazel].
- The story is set in [a cozy woodland village where lanterns glow at night].
- The character faces a small, calming challenge: [she can't find her favorite star in the cloudy sky, so she follows fireflies to a hilltop].
- End with a peaceful resolution that teaches [patience and trusting that good things are still there, even when you can't see them].
- Use short, rhythmic sentences that sound natural when read aloud.`
    },
    {
      title: "Short Fiction Narration",
      content: `Write a short story suitable for audiobook-style narration.
- Genre: [contemporary mystery].
- The protagonist is [a retired librarian who notices something odd about the new neighbor's daily routine].
- The central tension is [small, unexplained details that build toward a surprising but satisfying reveal].
- Tone: [quiet suspense with touches of warmth].
- Write in a clear, flowing style with varied sentence lengths to keep the listener engaged.`
    },
    {
      title: "Poetry Reading",
      content: `Write a poem meant to be performed aloud.
- Topic: [the feeling of a city waking up at dawn].
- Style: [free verse with a natural spoken rhythm].
- Mood: [reflective and hopeful].
- Include vivid sensory details: [sounds of the first bus, light hitting wet pavement, the smell of fresh bread from a bakery].
- Use pauses and line breaks that guide the reader's pacing and breath.`
    }
  ]
};
